<div class="w-full h-full">
  <div class="flex h-full">

    <mojo-list-widget-table [table]="table | async"
                            [showTitle]="false"
                            [loading]="loading$ | async"
                            [showPaginator] = "false"
                            [availableColumns]="availableColumns | async"
                            (dialogSaved)="selectedColumnsChanged($event)"
                            (onColReorder)="columnsReordered($event)"
                            (onRowSelect)="rowSelected($event)"
                            (resetColumns)="resetColumns()"
                            (onColResize)="columnsResized($event)">

      <ng-template #colGroupTemplate let-columns="columns">
        <col class="ng-star-inserted ui-resizable-column`"/>
      </ng-template>
      <ng-template #rowTemplate let-rowData="rowData" let-columns="columns">
        <ng-container *ngIf="rowTemplateRef; then customRowTemplate  else defaultRowTemplate "></ng-container>
        <ng-template #defaultRowTemplate>
          <td *ngFor="let col of columns" [hidden]="col.isSystemColumn" class="ui-resizable-column" mojoAlignTableColumn
              [columnType]="col.type">
            <ng-container *ngIf="getRowHref; then linkTemplate else defaultValueTemplate"></ng-container>
            <ng-template #defaultValueTemplate>{{ listWidget.formatByColumnType(rowData[col.field], col.type) }}
            </ng-template>
            <ng-template #linkTemplate><a [href]="getRowHref(rowData)"
                                          (click)="triggerRowSelected($event, rowData)">{{ listWidget.formatByColumnType(rowData[col.field], col.type) }}</a>
            </ng-template>
          </td>
        </ng-template>
        <ng-template #customRowTemplate>
          <ng-container [ngTemplateOutlet]="rowTemplateRef"
                        [ngTemplateOutletContext]="{ rowData: rowData, columns: columns }"></ng-container>
        </ng-template>
      </ng-template>
    </mojo-list-widget-table>
  </div>
</div>
